/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Communication_Channel_WhatsapInputs */

const en_communication_channel_whatsap = /** @type {(inputs: Communication_Channel_WhatsapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communication Channel (WhatsApp/Phone)`)
};

const es_communication_channel_whatsap = /** @type {(inputs: Communication_Channel_WhatsapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canal de comunicación (WhatsApp/Teléfono)`)
};

const fr_communication_channel_whatsap = /** @type {(inputs: Communication_Channel_WhatsapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canal de communication (WhatsApp/Téléphone)`)
};

const de_communication_channel_whatsap = /** @type {(inputs: Communication_Channel_WhatsapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommunikationskanal (WhatsApp/Telefon)`)
};

const ja_communication_channel_whatsap = /** @type {(inputs: Communication_Channel_WhatsapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連絡先チャネル (WhatsApp/電話番号)`)
};

const zh_communication_channel_whatsap = /** @type {(inputs: Communication_Channel_WhatsapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沟通渠道 (WhatsApp/电话)`)
};

const ar_communication_channel_whatsap = /** @type {(inputs: Communication_Channel_WhatsapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قناة التواصل (واتساب/هاتف)`)
};

const id_communication_channel_whatsap = /** @type {(inputs: Communication_Channel_WhatsapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saluran Komunikasi (WhatsApp/Telepon)`)
};

const it_communication_channel_whatsap = /** @type {(inputs: Communication_Channel_WhatsapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canale di Comunicazione (WhatsApp/Telefono)`)
};

const ru_communication_channel_whatsap = /** @type {(inputs: Communication_Channel_WhatsapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Канал связи (WhatsApp/Телефон)`)
};

const pt_communication_channel_whatsap = /** @type {(inputs: Communication_Channel_WhatsapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canal de Comunicação (WhatsApp/Telefone)`)
};

const ko_communication_channel_whatsap = /** @type {(inputs: Communication_Channel_WhatsapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커뮤니케이션 채널 (WhatsApp/전화번호)`)
};

/**
* | output |
* | --- |
* | "Communication Channel (WhatsApp/Phone)" |
*
* @param {Communication_Channel_WhatsapInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const communication_channel_whatsap = /** @type {((inputs?: Communication_Channel_WhatsapInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Communication_Channel_WhatsapInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_communication_channel_whatsap(inputs)
	if (locale === "es") return es_communication_channel_whatsap(inputs)
	if (locale === "fr") return fr_communication_channel_whatsap(inputs)
	if (locale === "de") return de_communication_channel_whatsap(inputs)
	if (locale === "ja") return ja_communication_channel_whatsap(inputs)
	if (locale === "zh") return zh_communication_channel_whatsap(inputs)
	if (locale === "ar") return ar_communication_channel_whatsap(inputs)
	if (locale === "id") return id_communication_channel_whatsap(inputs)
	if (locale === "it") return it_communication_channel_whatsap(inputs)
	if (locale === "ru") return ru_communication_channel_whatsap(inputs)
	if (locale === "pt") return pt_communication_channel_whatsap(inputs)
	return ko_communication_channel_whatsap(inputs)
});